const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/ai2`;

const headers = () => {
  const h = { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}` };
  const loc = localStorage.getItem("currentLocationId");
  if (loc) h["X-Location-Id"] = loc;
  return h;
};

export const AI2 = BASE;

export async function streamAsk(body, onEvent, signal) {
  const res = await fetch(`${BASE}/ask`, { method: "POST", headers: headers(), body: JSON.stringify(body), signal });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `Request failed (${res.status})`);
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    parts.forEach((p) => p.startsWith("data: ") && onEvent(JSON.parse(p.slice(6))));
  }
}

export const visibleText = (t) => (t || "").split("<meta>")[0].replace(/<meta?$|<me?$|<m?$/, "").trimEnd();
